export default __webpack_public_path__ + "static/media/Blog2.1c728b65.png";